<template>
	<section class="report">
		<section class="report-wrap">
			<header-ope
				@headerBtn="headerBtn"
				@tabHandleClick="tabHandleClick"
				:schoolBaseInfo="schoolBaseInfo"
				:scrollTop="scrollTop"
				:headerTabInfo="{ headerList, tabActiveVal }"
				class="header-opess"
			></header-ope>
			<basicInfo :basicInfo="examBasic" :isTableShowMore="true" ref="basicInfo"></basicInfo>
			<interval></interval>
			<topic-analiysis
				@secondTitleOpe="lookOriginPage"
				@lookOriginQus="lookOriginQus"
				:quoteTable="quoteTable"
				:subOrObjOptions="subOrObjOptions"
				:isShowOpeColumn="true"
				:isTableShowMore="true"
				:scatterList="scatterList"
			>
			</topic-analiysis>
			<footer class="end"></footer>
		</section>
		<section class="origin-page" v-if="originPage">
			<i class="iconfont iconguanbi" @click="closeOriginPage"></i>
			<img v-for="(item, index) in originPageList" :src="item.imageAddr" alt="" :key="index" />
		</section>
		<section class="origin-qus" v-if="originQus">
			<i class="iconfont iconguanbi" @click="closeOriginQs"></i>
			<div class="origin-qus-content">
				<img v-for="(item, index) in originQsList" :src="item" :key="index" />
			</div>
		</section>
	</section>
</template>

<script>
import cookies from '@/utils/cookie'
export default {
	name: 'quality-report',
	components: {
		topicAnaliysis: () => import('../utils/components/quality/topic-analysis'),
		headerOpe: () => import('../utils/components/quality/header'),
		basicInfo: () => import('../utils/components/quality/basic-info'),
		interval: () => import('../utils/components/interval')
	},
	data() {
		return {
			FIRST: 0,
			originPage: false,
			originQus: false,
			schoolBaseInfo: {},
			headerList: [],
			tabActiveVal: null,
			tabActiveLabel: '',
			quoteTable: [],
			subOrObjOptions: {},
			scatterList: [],
			originPageList: [],
			originQsList: [],
			query: this.$route.query,
			examBasic: {},
			scrollTop: 0
		}
	},
	created() {
		this.$screenRation()
		const token = this.query.token
		cookies.set('token', token)
		this.getSubjectList()
	},
	methods: {
		// 获取体块列表
		getSubjectList() {
			const params = {
				examId: this.query.examId,
				schoolId: this.query.schoolId
			}
			this.$post('reportApi/selectSubjectInfo', params).then(res => {
				this.schoolBaseInfo = res.data
				let headList = []
				res.data.subjectList.forEach(res => {
					headList.push({ name: `${res.gradeName}${res.subName}`, id: res.pkId })
				})
				const firstInfo = res.data.subjectList[this.FIRST]
				this.tabActiveVal = firstInfo.pkId
				this.tabActiveLabel = firstInfo.gradeName + firstInfo.subName
				this.headerList = headList
				this.quoatDetail()
				this.subOrObjDistribute()
				this.getScatterList()
				this.examBasicInfo()
			})
		},
		// 试题分析指标明细表 列表
		quoatDetail() {
			const params = {
				examId: this.query.examId,
				schoolId: this.query.schoolId,
				subjectId: this.tabActiveVal
			}
			this.$post('reportApi/selectQuestionDetails', params).then(res => {
				this.quoteTable = res.data
			})
		},
		// 主观题 客观题
		subOrObjDistribute() {
			const params = {
				examId: this.query.examId,
				schoolId: this.query.schoolId,
				examSubjectId: this.tabActiveVal
			}
			this.$post('reportApi/selectQuestionDifficult', params).then(res => {
				let lenged = []
				let objDataList = []
				let subDataList = []
				res.data.data[0].forEach((resp, index) => {
					if (index > 1) {
						lenged.push(resp.label)
						objDataList.push({
							name: resp.label,
							value: resp.value.includes(';') ? resp.value.split(';').length - 1 : 0
						})
						subDataList.push({
							name: res.data.data[2][index].label,
							value: res.data.data[2][index].value.replaceAll('；', '][').split('[').length - 1
						})
					}
				})
				this.subOrObjOptions = {
					difficultTableOption: res.data.data,
					difficultRate: res.data.subjectRate,
					lenged: lenged,
					objDataList: objDataList,
					subDataList: subDataList
				}
			})
		},
		//	 ECHARTS 散点图
		getScatterList() {
			const params = {
				examId: this.query.examId,
				schoolId: this.query.schoolId,
				examSubjectId: this.tabActiveVal
			}
			this.$post('reportApi/getQuestionDifficulty', params).then(res => {
				this.scatterList = res.data.data
			})
		},
		//
		lookOriginPage() {
			const params = {
				examId: this.query.examId,
				examSubjectId: this.tabActiveVal,
				type: 4,
				pageCode: 1
			}
			this.$post('examImgInfo/getOssImage', params).then(res => {
				if (res.data.length === 0) {
					this.$message({ message: '暂无原卷', type: 'error', duration: 3000 })
					return false
				}
				this.originPage = true
				this.originPageList = res.data
			})
		},
		//	关闭原卷
		closeOriginPage() {
			this.originPage = false
		},
		// 查看原题
		lookOriginQus(val) {
			const params = {
				examId: this.query.examId,
				subjectId: this.tabActiveVal,
				topicMold: val.other.topicMold,
				tpcId: val.other.tpcId
			}
			this.$post('reportApi/selectArtwork', params).then(res => {
				if (!res.data || res.data.length === 0) {
					this.$message({ type: 'error', message: '暂无原题', duration: 3000 })
					return false
				}
				this.originQus = true
				this.originQsList = res.data
			})
		},
		// 关闭原题
		closeOriginQs() {
			this.originQus = false
		},
		// 考试基本情况
		examBasicInfo() {
			const params = {
				examId: this.query.examId,
				subjectId: this.tabActiveVal,
				schoolId: this.query.schoolId
			}
			this.$post('reportApi/queryQuestionBaseInfo', params).then(res => {
				this.examBasic = res.data
			})
		},
		// 预览
		headerBtn() {
			this.$router.push({
				path: '/report/quality/preview',
				query: {
					token: this.query.token,
					examId: this.query.examId,
					schoolId: this.query.schoolId,
					subjectName: this.tabActiveLabel,
					subjectId: this.tabActiveVal
				}
			})
		},
		// 切换tab
		tabHandleClick(val) {
			this.tabActiveVal = val.tabActive
			this.tabActiveLabel = val.label
			this.quoatDetail()
			this.subOrObjDistribute()
			this.getScatterList()
			this.examBasicInfo()
		}
	}
}
</script>

<style lang="less" scoped>
.report {
	width: 100%;
	height: 100%;
	background: #f1f1f1;
	overflow: auto;
	.report-wrap {
		width: 1200px;
		margin: 10px auto;
		box-sizing: border-box;
		background: white;
		.report {
			width: 1200px;
			margin-top: 10px;
		}
		.end {
			width: 1200px;
			height: 50px;
			background: #f6f6f6;
			margin: 15px auto 10px;
			border-radius: 2px;
			text-align: center;
			line-height: 100px;
			font-size: 26px;
			color: white;
			letter-spacing: 10px;
		}
		/deep/ .el-tabs__header {
			margin: 0;
			background: white;
		}
		/deep/.el-tabs__item {
			height: 60px;
			line-height: 60px;
		}
	}
	.origin-page {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		z-index: 5;
		background: white;
		overflow: auto;
		img {
			max-width: 100%;
		}
	}
	.origin-qus {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		z-index: 5;
		display: flex;
		justify-content: center;
		align-items: center;
		background: rgba(0, 0, 0, 0.8);
		.origin-qus-content {
			max-width: 80%;
			max-height: 90%;
			background: white;
			border-radius: 8px;
			overflow: auto;
			img {
				width: 100%;
			}
		}
		.iconguanbi {
			color: #fcfcfc;
		}
	}
	.iconfont {
		position: fixed;
		right: 20px;
		top: 20px;
		font-size: 35px;
		color: #333333;
		cursor: pointer;
	}
}
</style>
